import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';

import type { ThoughtspotLiveboards } from '@jane/business-admin/types';

interface Props {
  authorizedLiveboards: ThoughtspotLiveboards;
  authState: 'Success' | 'Failed' | undefined;
  isAuthenticating: boolean;
  isFetchingLiveboards: boolean;
  navLiveboards: ThoughtspotLiveboards;
  username: string;
}

const AnalyticsPageContext = createContext<Props>({
  authState: undefined,
  username: '',
  authorizedLiveboards: {},
  isAuthenticating: true,
  isFetchingLiveboards: true,
  navLiveboards: {},
});
AnalyticsPageContext.displayName = 'AnalyticsPage';

export const useAnalyticsPage = () => useContext(AnalyticsPageContext);

export const AnalyticsPageProvider = ({
  authState,
  children,
  username = '',
  authorizedLiveboards = {},
  navLiveboards = {},
  isFetchingLiveboards = true,
  isAuthenticating = true,
}: PropsWithChildren<Props>) => (
  <AnalyticsPageContext.Provider
    value={{
      authState,
      username,
      authorizedLiveboards,
      navLiveboards,
      isFetchingLiveboards,
      isAuthenticating,
    }}
  >
    {children}
  </AnalyticsPageContext.Provider>
);
